<template>
  <ul :class="$style.root">
    <li
      v-for="entry in data"
      :key="entry?.id"
      :class="$style.item"
    >
      <pagesJournalsQueryListThumbnailComponent
        :data="entry"
      />
    </li>
  </ul>
</template>

<script lang="ts" setup>

const props = defineProps({
  data: {
    type: Array,
    required: true
  }
})
</script>

<style module lang="scss">
.root {
  composes: reset-list from global;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: var(--unit--default);
  padding: 0 var(--unit--default);

  @media (max-width: $breakpoint-m) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: $breakpoint-s) {
    grid-template-columns: 1fr;
  }
}

.item {
  border-top: var(--stroke--medium) solid;
  padding-top: calc(var(--unit--vertical) / 2);
}
</style>
